// extracted by mini-css-extract-plugin
export default {"container":"_18Vq1","placeholder":"HOi00"};